import { DownloadOrdersDataRequest, DownloadOrdersDataResponse } from './download-oreders-types';
import { API_ORDER_PREFIX } from '@shared/config/api/api-prefixes';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { orderBaseApi } from '@entities/order/api/base';

export const downloadOrdersApi = orderBaseApi.injectEndpoints({
    endpoints: (build) => ({
        downloadOrders: build.mutation<DownloadOrdersDataResponse, DownloadOrdersDataRequest>({
            query(parameters) {
                return {
                    url: `${API_ORDER_PREFIX}/download${queryParametersToString({ ...parameters })}`,
                    method: 'GET',
                    responseHandler: async (response) =>
                        window.location.assign(window.URL.createObjectURL(await response.blob())),
                    cache: 'no-cache',
                };
            },
        }),
    }),
});

export const { useDownloadOrdersMutation } = downloadOrdersApi;
